const Api = {
  ADD_SUBSCRIPTION: "add-subscriber",
  GET_ROADMAP: "get-active-roadmap",
  GET_TEAM: "get-landing-team",
  GET_FAQ: "get-landing-faq",
  GET_CMS: "get-user-cms",
  ADD_CONTACT_US: "add-landing-contact-us",
};
export { Api };
